// Meervoud per taal. Intl.PluralRules bestaat pas vanaf Safari 13 (de oude iPad draait iOS 12.2),
// dus: Intl als hij er is, anders een kleine eigen tabel voor onze zes talen (CLDR-regels, alleen
// gehele en eenvoudige getallen; een test vergelijkt de tabel met Intl in Node).
import { normalizeLocale } from './locales.js';
const cache = {};
function intlRules(lang) {
    var _a;
    if (lang in cache)
        return (_a = cache[lang]) !== null && _a !== void 0 ? _a : null;
    let rules;
    try {
        const ctor = Intl.PluralRules;
        rules = typeof ctor === 'function' ? new ctor(lang) : null;
    }
    catch {
        rules = null;
    }
    cache[lang] = rules;
    return rules;
}
/** Eigen tabel (zonder Intl): de CLDR-regels van onze talen. Exporteerd voor de test. */
export function fallbackCategory(lang, n) {
    const abs = Math.abs(n);
    const int = Math.floor(abs);
    const isInt = int === abs;
    switch (lang) {
        case 'ar': {
            if (!isInt)
                return 'other';
            if (abs === 0)
                return 'zero';
            if (abs === 1)
                return 'one';
            if (abs === 2)
                return 'two';
            const mod = abs % 100;
            if (mod >= 3 && mod <= 10)
                return 'few';
            if (mod >= 11 && mod <= 99)
                return 'many';
            return 'other';
        }
        case 'fr':
            // i = 0,1 → one (0, 1, 1,5); grote ronde miljoenen → many.
            if (int === 0 || int === 1)
                return 'one';
            if (isInt && int !== 0 && int % 1000000 === 0)
                return 'many';
            return 'other';
        default:
            // nl, en, de, tr: alleen precies 1 is enkelvoud.
            return isInt && abs === 1 ? 'one' : 'other';
    }
}
export function pluralCategory(locale, n) {
    const lang = normalizeLocale(locale).slice(0, 2);
    if (!isFinite(n))
        return 'other';
    const rules = intlRules(lang);
    if (rules) {
        try {
            const cat = rules.select(n);
            if (cat === 'zero' ||
                cat === 'one' ||
                cat === 'two' ||
                cat === 'few' ||
                cat === 'many' ||
                cat === 'other')
                return cat;
        }
        catch {
            // val terug op de tabel
        }
    }
    return fallbackCategory(lang, n);
}
/** Kiest de vorm; een ontbrekende categorie valt terug op `other` (nooit een lege tekst). */
export function pluralForm(forms, category) {
    const form = forms[category];
    return typeof form === 'string' && form.length > 0 ? form : forms.other;
}
//# sourceMappingURL=plural.js.map